import { PropsWithChildren } from 'react'

import { LoginContainer } from 'features/auth/login/styles'
import Footer from 'components/Footer/'
import LoginHeader from '../LoginHeader/LoginHeader'
import LoginBgImage from '../LoginBgImage/LoginBgImage'
import { StyledLoginContainer } from '../LoginContainer/styles'
import { StyledLoginInner, StyledLoginWrapper } from './styles'

function LoginCommonLayout(props: PropsWithChildren<{}>) {
  return (
    <StyledLoginWrapper>
      <LoginBgImage />
      <LoginContainer>
        <LoginHeader />
        <StyledLoginContainer>
          <StyledLoginInner>{props.children}</StyledLoginInner>
        </StyledLoginContainer>
      </LoginContainer>
      <Footer />
    </StyledLoginWrapper>
  )
}

export default LoginCommonLayout
